import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export type ExplorerMessagingLimitResponse = {
  isExplorer: boolean;
  used?: number;
  limit?: number;
  remaining?: number;
  weekStartUtc?: string;
  weekResetsUtc?: string;
  canSendMessage?: boolean;
};

interface Props {
  userId: string;
  enabled?: boolean;
}

export function useGetExplorerMessagingLimit({ userId, enabled = true }: Props) {
  return useQuery({
    enabled: enabled && !!userId,
    queryKey: ["explorerMessagingLimit", userId],
    queryFn: async () => {
      const res = await axiosInstance.get<ExplorerMessagingLimitResponse>(
        getAPIURL(`/User/explorerMessagingLimit/${userId}/`)
      );
      return res.data;
    },
    staleTime: 30_000,
  });
}
